import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { api } from "@/lib/api";

const rs = (v) => "Rs. " + Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export async function fetchReceipt(invoiceId) {
  const { data } = await api.get(`/fees/invoices/${invoiceId}/receipt`);
  return data;
}

export async function downloadReceiptPdf(invoiceId) {
  const { invoice, payments, student, branch } = await fetchReceipt(invoiceId);
  const doc = new jsPDF();
  doc.setFillColor(91, 33, 182);
  doc.rect(0, 0, 210, 30, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(20);
  doc.text("SPARKORA EDU", 14, 15);
  doc.setFontSize(10);
  doc.text(`${branch.name || ""} ${branch.code ? `(${branch.code})` : ""} ${branch.location ? `- ${branch.location}` : ""}`, 14, 23);
  doc.setFontSize(14);
  doc.text("FEE RECEIPT", 196, 15, { align: "right" });

  doc.setTextColor(30, 30, 30);
  doc.setFontSize(10);
  const left = [
    `Invoice No: ${invoice.receipt_no}`,
    `Period: ${invoice.period}`,
    `Due date: ${invoice.due_date}`,
    `Status: ${invoice.status.toUpperCase()}`,
  ];
  const right = [
    `Student: ${student.name || ""}`,
    `Admission No: ${student.admission_number || ""}`,
    `Class: ${invoice.class_name} / ${invoice.section}`,
    `Parent: ${student.father_name || ""}`,
  ];
  left.forEach((t, i) => doc.text(t, 14, 42 + i * 6));
  right.forEach((t, i) => doc.text(t, 110, 42 + i * 6));

  autoTable(doc, {
    startY: 70,
    head: [["Fee head", "Amount"]],
    body: invoice.items.map((it) => [it.name, rs(it.amount)]),
    foot: [
      ...(invoice.discount > 0 ? [["Subtotal", rs(invoice.gross)], [invoice.discount_note || "Discount", "- " + rs(invoice.discount)]] : []),
      ["Total", rs(invoice.total)], ["Paid", rs(invoice.paid)], ["Balance due", rs(invoice.balance)],
    ],
    headStyles: { fillColor: [124, 58, 237] },
    footStyles: { fillColor: [245, 243, 255], textColor: [30, 30, 30] },
    columnStyles: { 1: { halign: "right" } },
  });

  if (payments.length) {
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 10,
      head: [["Receipt No", "Date", "Mode", "Reference", "Amount"]],
      body: payments.map((p) => [p.receipt_no, new Date(p.received_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }), p.mode.toUpperCase(), p.reference || "-", rs(p.amount)]),
      headStyles: { fillColor: [16, 185, 129] },
      columnStyles: { 4: { halign: "right" } },
    });
  }
  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.text(`Generated on ${new Date().toLocaleString("en-IN")} - computer generated receipt.`, 14, 287);
  doc.save(`${invoice.receipt_no}.pdf`);
}
